import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Table, CardFooter, FormGroup, Input } from 'reactstrap';
import { useAlert } from 'hooks';
import AlertModal from 'components/AlertModal';
import { getErrorMessage } from 'helpers/errors';
import { getIOMAACobrar, IOMAaCobrar, IOMAaCobrarOptions } from 'features/insurers/insurersAPI';
import { fCurrency } from 'helpers/formatNumber';
import Pagination from 'components/Pagination';
import CollapsibleCard from '../../components/CollapsibleCard';

export default function IOMAACobrar() {
  const [isLoading, setIsLoading] = useState(true);
  const [showAlert, message, alert] = useAlert(false, '');
  const [data, setData] = useState<IOMAaCobrar>();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [terms, setTerms] = useState<IOMAaCobrar['terms']>([]);
  const [selectedTerm, setSelectedTerm] = useState<IOMAaCobrar['selectedTerm']>('');

  const [currentOptions, setCurrentOptions] = useState<IOMAaCobrarOptions>({});

  useEffect(() => {
    setIsLoading(true);

    getIOMAACobrar()
      .then(newData => {
        setData(newData);
        setTerms(newData.terms);
        setSelectedTerm(newData.selectedTerm);
        setCurrentPage(newData.pagination.current);
        setTotalPages(newData.pagination.total);
      })
      .catch(err => {
        alert(true, getErrorMessage(err) || 'No se pudo obtener la información de IOMA');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const changePage = (newPage: number) => {
    setIsLoading(true);

    const newOptions = {
      ...currentOptions,
      page: newPage,
    };

    setCurrentOptions(newOptions);

    getIOMAACobrar(newOptions)
      .then(newData => {
        setData(newData);
        setTerms(newData.terms);
        setSelectedTerm(newData.selectedTerm);
        setCurrentPage(newData.pagination.current);
        setTotalPages(newData.pagination.total);
      })
      .catch(err => {
        alert(true, getErrorMessage(err) || 'No se pudo obtener la información de IOMA');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const changeTerm = (newTerm: string) => {
    setIsLoading(true);
    setSelectedTerm(newTerm);

    const newOptions = {
      ...currentOptions,
      page: 1,
      term: newTerm,
    };

    setCurrentOptions(newOptions);

    getIOMAACobrar(newOptions)
      .then(newData => {
        setData(newData);
        setTerms(newData.terms);
        setSelectedTerm(newData.selectedTerm);
        setCurrentPage(newData.pagination.current);
        setTotalPages(newData.pagination.total);
      })
      .catch(err => {
        alert(true, getErrorMessage(err) || 'No se pudo obtener la información de IOMA');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="content">
      <AlertModal
        isOpen={showAlert}
        message={message}
        onClose={() => alert(false)}
      />
      <Row>
        <Col md={12}>
          <CollapsibleCard title="Filtros">
            <Row>
              <Col md="3">
                <FormGroup>
                  <label>Periodo</label>
                  <Input
                    type="select"
                    onChange={ event => changeTerm(event.target.value) }
                    value={ selectedTerm }
                    disabled={ isLoading }
                  >
                    { isLoading && terms.length === 0
                      ? <option value="">Cargando...</option>
                      : terms.map(term => <option key={ term } value={ term }>{ term }</option>)
                    }
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          </CollapsibleCard>
          <Card>
            <CardHeader>
              <Row>
                <Col md={8} style={{ fontSize: '1.5rem', marginTop: '10px' }}>IOMA a Cobrar</Col>
                <Col md={4} className="text-right">
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Table>
                <thead>
                  <tr>
                    <th>Tipo</th>
                    <th>Periodo</th>
                    <th>Afiliado</th>
                    <th>Sesiones</th>
                    <th style={{ textAlign: 'right' }}>Importe Facturado</th>
                    <th style={{ textAlign: 'right' }}>Coseguro</th>
                  </tr>
                </thead>
                <tbody>
                  { isLoading
                    ?
                      <tr>
                        <td colSpan={6} style={{ textAlign: 'center', padding: '3rem 0' }}>
                          <div
                            className="spinner-border text-primary"
                            style={{ width: '3rem', height: '3rem' }}
                            role="status"
                          >
                            <span className="sr-only">Cargando...</span>
                          </div>
                        </td>
                      </tr>
                    : data?.data.map((row, idx) => (
                      <tr key={idx}>
                        <td>{ row.obras }</td>
                        <td>{ row.periodo }</td>
                        <td>{ row.afiliado }</td>
                        <td>{ row.sesiones }</td>
                        <td style={{ textAlign: 'right' }}>{ fCurrency(row.facturado) }</td>
                        <td style={{ textAlign: 'right' }}>{ fCurrency(row.coseguro) }</td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
            </CardBody>
            <CardFooter>
              <Pagination
                page={ currentPage }
                pages={ totalPages }
                onChangePage={ changePage }
              />
            </CardFooter>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
